import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import { Button } from '@gn-audio/jss-components/components/Button/Button';

import Spinner from 'components/Shared/Spinner';

import { useFormState } from '../../contexts/FormState/FormStateContext';
import { ButtonViewModel } from '../../types/button';

const SubmitButton: React.FC<FieldProps<ButtonViewModel>> = ({ field, onButtonClick }) => {
  const { busyButtonId } = useFormState();
  const { id, name } = field.buttonField;
  const isButtonBusy = id === busyButtonId;

  const alignmentConfig = {
    'text-left': 'text-left',
    'text-center': 'text-center',
    'text-right': 'text-right',
  };

  // Sitecore Forms navigation step values: '1' = Next, '-1' = Previous, '0' = Submit
  const isPreviousButton = field.navigationStepField.value === '-1';

  return (
    <Button
      type="submit"
      formNoValidate={isPreviousButton}
      variant={isButtonBusy ? 'tertiary' : 'primary'}
      size="l"
      id={id}
      name={name}
      value={field.model.title}
      className={classNames(
        'w-full',
        alignmentConfig[field.model.align as keyof typeof alignmentConfig]
      )}
      onClick={() => onButtonClick(name)}
      busy={isButtonBusy}
    >
      {isButtonBusy ? <Spinner /> : <span>{field.model.title}</span>}
    </Button>
  );
};
export default SubmitButton;
